import { ToolbarButton } from './ToolbarButton';
import { ArStore } from '../stores/ArStore';
import { GlobalHelper } from '../utils/GlobalHelper';

export class ToolbarButtonAR extends ToolbarButton {
    public componentWillMount(): void {
        this.addStoreListener(ArStore, this.onChange);
        this.onChange();
    }

    protected onClick = (): void => {
        if (this.state.active) {
            GlobalHelper.arManager.core.leaveAr();
        } else {
            GlobalHelper.arManager.core.enterAr();
        }
    };

    protected onChange = () => {
        this.setState({active: ArStore.getState().started});
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButtonAR.tsx